export default __webpack_public_path__ + "467929a7ff49eaa0241dd017779d92c6.png";